
const loadArrows = ($slickDots) => {
  let $slickActive = document.querySelector('.slick-dots .slick-active')

  const $left = document.querySelector('.left')
  const $right = document.querySelector('.right')

  const $slicks = $slickDots.children
  const $last = $slicks[$slicks.length-1]
  const $first = $slicks[0]

  if( $left ) {
    $left.style.display = 'block'
    $left.addEventListener('click', () => {
      $slickActive = document.querySelector('.slick-dots .slick-active')

      const $previous = $slickActive.previousElementSibling
      if( $previous ) {
        $previous.click()
        $slickActive = $previous
      } else {
        $last.click()
        $slickActive = $last
      }
    })
  }

  if( $right ) {
    $right.style.display = 'block'
    $right.addEventListener('click', () => {
      $slickActive = document.querySelector('.slick-dots .slick-active')

      const $next = $slickActive.nextElementSibling
      if( $next ) {
        $next.click()
        $slickActive = $next
      } else {
        $first.click()
        $slickActive = $first
      }
    })
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const slickDotsClassSelector = '.product-single__photo-slider .slick-dots'
  let $slickDots = document.querySelector( slickDotsClassSelector )
  
  // this look for the $slickDots elements each second until to find it on the DOM
  // because it is loaded using lazy load
  const interval = window.setInterval(() => {
    $slickDots = document.querySelector(slickDotsClassSelector)
    // const $list = document.querySelectorAll('.slick-dots')
    // console.log({ $list })

    if( $slickDots !== null ) {
      window.clearInterval(interval)
      loadArrows($slickDots)
    }

  }, 200)
})

// when screen is resize $slickDots is removed
// then we find it again only in small screens
// additionally, we load the arrows again
window.addEventListener('resize', () => {

  if( window.innerWidth <= 768 ) {
    const $slickDots = document.querySelector('.slick-dots')

    if( $slickDots ) {

      loadArrows($slickDots)
    }
  }
})